import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { CookieService } from 'ngx-cookie-service';

import { environment } from '../../../environments/environment';
import { BaseComponent } from '../../../shared/abstracts/base.abstract';

@Component({
    selector: 'app-support-beta',
    templateUrl: './support-beta.component.html',
    styleUrls: ['./support-beta.component.scss'],
})
export class SupportBetaComponent extends BaseComponent implements OnInit {
    public supportModalForm: FormGroup;

    constructor(private cookies: CookieService, private fb: FormBuilder) {
        super();
    }

    ngOnInit(): void {
        this.supportModalForm = this.fb.group({
            hideSupport: [false],
        });
        this.uns = this.supportModalForm.get('hideSupport').valueChanges.subscribe((val: boolean) => {
            if (val === true && !this.cookies.get('hideSupport')) {
                this.cookies.set('hideSupport', 'true', 30, '/', environment.cookieDomain, environment.cookieSecure);
            } else {
                this.cookies.set('hideSupport', 'false', 30, '/', environment.cookieDomain, environment.cookieSecure);
            }
        });
    }
}
